import './Productitem.scss';

function Productitem(props: any) {

  return (
    <div   >
      <div>
        <div className='touchAble cm-t-1rem cm-b-1rem border-radius div-box-shadow '>
          <div className='product-img-container'>
            <img className='product-image' alt="img" src={'https://lesfemmestesting.dominioninc.org/public/uploads/images/' + props.DataofProduct.image} ></img>
          </div>
          {props.DataofProduct.discount !== null && props.DataofProduct.discount !== 0 ? (
            <div className='off-contianer cm-r-4 cm-t-20'>
              <label className="bg-color-primary page-color pText cp-t-5 cp-b-5 cp-l-10 cp-r-10 " > {props.DataofProduct.discount}% OFF</label>
            </div>
          ) : null}
          {props.DataofProduct.is_bundle === 1 ? (
            <div className='bundle-contianer cm-l-5 cm-t-16'>
              <label className="bg-color-primary page-color pText cp-t-5 cp-b-5 cp-l-10 cp-r-10 " >Bundle</label>
            </div>
          ) : null}
          <div className="cp-r-5 cp-l-5" >
            <div className='labelText text-center primary-color cp-t-5 text-truncate'  >
              {props.DataofProduct.name}
            </div>
            {props.DataofProduct.manufacturer_name === null ? (
              <div className='text-center labelText ' style={{ color: 'white' }}>
                f
              </div>
            ) : (
              <div className=' text-center labelText text-truncate'>
                {props.DataofProduct.manufacturer_name}
              </div>
            )}
            {props.DataofProduct.discount === null || props.DataofProduct.discount === 0 ? (
              <div>
                <div className='  text-center pText cp-b-5 text-muted'>
                  AED {props.DataofProduct.unit_price.toFixed(2)}
                </div>
                <div className=' text-center pText cp-b-5' style={{ color: 'white' }}  >
                 .
                </div>
              </div>
            ) : (
              <div>
                <div className=' text-center  pText primary-color'>
                  AED {props.DataofProduct.discounted_price?.toFixed(2)}
                </div>
                <div className='text-center pText text-muted line-through cp-b-10'>
                  AED {props.DataofProduct.unit_price}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Productitem;
